import { Vendor } from 'mggp-player';
import { YandexWrapper } from './YandexWrapper';

const YANDEX_SDK_SRC = 'https://an.yandex.ru/system/video-ads-sdk/adsdk.js';

export default class MggpVendorYandex extends Vendor {
  static priority = 0;
  static mimeTypes = ['yandex'];
  static canPlay(type) {
    return MggpVendorYandex.mimeTypes.includes(type);
  }

  constructor(player, config) {
    super(player, config);
    this.wrapper = new YandexWrapper(player, this._onError, this._onEvent);
    this.podStarted = false;
    this.adStarted = false;
  }

  dispose = () => {
    this.wrapper.dispose();
  };

  load = (src, _, options) => {
    this.checkOptions(options);

    this._setState(5);
    new Promise((res, rej) => {
      if (!window.ya || !window.ya.videoAd) {
        const script = document.createElement('script');
        script.src = YANDEX_SDK_SRC;
        script.onload = res;
        script.onerror = rej;
        document.head.appendChild(script);
      } else {
        res();
      }
    })
      .then(() => this.wrapper.startProcessing(src))
      .catch(() => {
        this._onError();
      });
  };

  play = () => {
    this.wrapper.resume();
    this._setState(1);
  };

  pause = () => {
    this.wrapper.pause();
    this._setState(2);
  };

  stop = () => {
    this._setState(0);
    this.dispose();
  };

  seekTo() {}

  setVolume() {}

  mute() {}

  unMute() {}

  _onError = (...args) => {
    args.forEach(arg => {
      console.error('YANDEX_AD:', arg);
    });
    this.player.emit('ad:vendor:mediaError', args[0]);
    this.dispose();
  };

  _setState(newState) {
    newState = parseInt(newState);
    this.set('state', newState);
    this.emit('stateChange', newState);
  }

  _onEvent = eventName => (...args) => {
    // console.log(eventName, ...args);
    switch (eventName) {
      case 'AdStarted':
        this._setState(1);
        this.adStarted = true;
        break;

      case 'AdPodStarted':
        this.podStarted = true;
        break;

      case 'AdStopped':
        this._setState(0);
        if (!this.adStarted) {
          console.error('YANDEX: yandex got the ad but could not start it. "проигрывание AdPod было завершено до старта, на этапе инициализации"')
        }
        this.podStarted = false;
        this.adStarted = false;
        break;

      case 'AdPodImpression':
        this.player.emit('ad:internal:vastEvent', 'impression');
        break;

      case 'AdPodSkipped':
        this.player.emit('ad:internal:vastEvent', 'skip');
        break;

      case 'AdPodVideoFirstQuartile':
        this.player.emit('ad:internal:vastEvent', 'firstQuartile');
        break;

      case 'AdPodVideoMidpoint':
        this.player.emit('ad:internal:vastEvent', 'midpoint');
        break;

      case 'AdPodVideoThirdQuartile':
        this.player.emit('ad:internal:vastEvent', 'thirdQuartile');
        break;

      case 'AdPodStopped':
        if (this.podStarted) {
          this.player.emit('ad:internal:vastEvent', 'complete');
        }
        this.podStarted = false;
        break;
    }
  };
}
